import {object, SchemaOf} from 'yup';

import {yupString} from 'shared/web';

export const correctiveTaxDocumentFormValidations = (isSystem?: boolean) =>
  object().shape({
    branchId: isSystem ? (yupString.nullable() as SchemaOf<string>) : yupString.required(),
    createCorrectiveTaxDocumentType: yupString.required(),
  });
